import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type PdfType = 'RESET_PASSWORD'
 |'NEW_CREDENTIAL' 
 |'STUDENT_CARD'
 |'STUDENT_PROCESS' 
 |'SUBSCRIPTION'
 |'CERTIFICATE'
 |'DECLARATION'
 |'CREDENTIAL'
 |'DIPLOMA'
 |'INVOICE'
 |'RECEIPT'
 |'STUDENT_SITUATION'
 |'STUDENTS_LIST'
 |'STUDENTS_GRADES'
 |'REFERENCES'
 ;

interface PdfPreviewState {
  type: PdfType;
}

const initialState: PdfPreviewState = {
  type: 'RESET_PASSWORD'
};

export const pdfPreviewSlice = createSlice({
  name: "pdfPreview",
  initialState,
  reducers: {
    setPdfPreviewType: (state, action: PayloadAction<PdfType>) => { state.type = action.payload }
  }
});

export const { setPdfPreviewType } = pdfPreviewSlice.actions;

export default pdfPreviewSlice.reducer;